<template>
  <div class="login-container">
    <div class="login-form">
      <div class="login-header">
        <h1>客服系统登录</h1>
      </div>

      <el-form
        ref="loginForm"
        :model="form"
        :rules="rules"
        label-width="0"
        @submit.native.prevent="handleLogin"
      >
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            size="large"
            clearable
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="large"
            clearable
            show-password
          />
        </el-form-item>

        <!-- <el-form-item>
          <el-checkbox v-model="form.rememberMe">记住我</el-checkbox>
        </el-form-item> -->

        <el-form-item>
          <el-button
            type="primary"
            size="large"
            :loading="loading"
            native-type="submit"
            style="width: 100%"
          >
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>

        <!-- IP地址显示区域 -->
        <el-form-item v-if="currentIp" class="ip-display">
          <div class="ip-info">
            <span class="ip-label">当前IP地址：</span>
            <span class="ip-value">{{ currentIp }}</span>
          </div>
        </el-form-item>
        <el-form-item v-else class="ip-display">
          <div class="ip-info">
            <span class="ip-label">正在获取IP地址...</span>
          </div>
        </el-form-item>
      </el-form>

      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: '',
        rememberMe: false
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false,
      errorMessage: '',
      currentIp: ''
    }
  },
  mounted() {
    this.fetchIpAddress()
  },
  methods: {
    async fetchIpAddress() {
      try {
        // 使用ipify.org的API获取公网IP地址
        const response = await fetch('https://api.ipify.org?format=json')
        if (response.ok) {
          const data = await response.json()
          this.currentIp = data.ip
        } else {
          // 如果ipify失败，尝试备用API
          await this.fetchIpAddressFallback()
        }
      } catch (error) {
        console.error('获取IP地址失败:', error)
        // 尝试备用方法
        await this.fetchIpAddressFallback()
      }
    },
    
    async fetchIpAddressFallback() {
      try {
        // 备用API：使用另一个免费的IP查询服务
        const response = await fetch('https://api64.ipify.org?format=json')
        if (response.ok) {
          const data = await response.json()
          this.currentIp = data.ip
        } else {
          this.currentIp = '无法获取IP地址'
        }
      } catch (error) {
        console.error('备用IP获取失败:', error)
        this.currentIp = '无法获取IP地址'
      }
    },

    async handleLogin() {
      try {
        await this.$refs.loginForm.validate()
      } catch (error) {
        return
      }

      this.loading = true
      this.errorMessage = ''

      try {
        const response = await this.$store.dispatch('login', {
          username: this.form.username,
          password: this.form.password
        })
        console.log(response,1111122234345);
        
        if (response.code === 200) {
          this.$message.success('登录成功')
          this.$router.push('/chat')
        } else {
          this.errorMessage = response.msg || '登录失败'
        }
      } catch (error) {
        console.error('Login error:', error)
        this.errorMessage = error.message || '登录失败，请检查网络连接'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-form {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 400px;
  max-width: 90%;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h1 {
  color: #333;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 600;
}

.error-message {
  color: #f56c6c;
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
}

/* IP地址显示样式 */
.ip-display {
  margin-top: 10px;
  margin-bottom: 0 !important;
}

.ip-info {
  width: 100%;

  padding: 8px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.ip-label {
  color: #606266;
  font-size: 14px;
  font-weight: 500;
}

.ip-value {
  color: #409eff;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Courier New', monospace;
  margin-left: 4px;
}
</style>
